import CacheDataInterface from "@app/Interface/CacheDataInterface";
import CacheDataModel from "@app/Model/CacheDataModel";
import CacheType from "@app/Type/CacheType";

export default class ApiCache {

    static API_CACHE_KEY = "API_CACHE";

    /**
     * 
     * @param url     url of request
     * @param content content object to store
     * @param stale   Optional: number of minutes after creation the data becomes stale
     */
    static set = (url: string, content: CacheType, stale?: number): void => {

        let updatedCache: CacheDataInterface[] = [];

        const dataToSet = new CacheDataModel(url, JSON.stringify(content), stale );

        // get the current cache
        const persistedData = localStorage.getItem(ApiCache.API_CACHE_KEY);

        const currentCache: CacheDataInterface[] = persistedData ? JSON.parse(persistedData) : [];

        let filteredCurrentCache: CacheDataInterface[] = [];

        // see if we need to remove a duplicate entry
        const dataIsCached = currentCache.find(cache => cache.url === dataToSet.url);

        if (dataIsCached) {
            
            filteredCurrentCache = currentCache.filter(item => item.url != url);
            
        } else {

            filteredCurrentCache = [...currentCache];
        }

        // add the new item 
        updatedCache = [...filteredCurrentCache, dataToSet];

        // save updated cache to local storage
        localStorage.setItem(ApiCache.API_CACHE_KEY, JSON.stringify(updatedCache));

    }

    /**
     * Attempts to find the content data
     * Will first check lastupdated, then if there's a staledate, it checks staledate
     * 
     * @param url         URL of get request
     * @param lastUpdated Optional: If cache data is older than lastUpdate, return null
     * @returns 
     */
    static get = (url: string, lastUpdated?: Date): CacheDataInterface | null => {

        // get the current cache 
        const persistedData = localStorage.getItem(ApiCache.API_CACHE_KEY);

        const currentCache: CacheDataInterface[] = persistedData ? JSON.parse(persistedData) : [];

        // attempt to find the item
        const data = currentCache.find(cache => cache && cache.url === url);

        // if no match return null
        if (!data) {
            return null;
        }

        // if found AND there's a lastUpdated paramter, 
        // then compare the item's date to the lastUpdated date
        // if cache is older than lastUpdated, then return null;
        if (lastUpdated && data.date < lastUpdated) {
            return null;
        } 
        
        // if found AND the item has a staleDate
        // compare current date, if staleDate is older than current date, then return null
        const currentDate = new Date();
        if (data.staleDate && new Date(data.staleDate) < currentDate) {
            return null;
        }

        // if we make it here, return the item
        return data;

    }

    static deleteNavigationData = (): void => {

        // get the current cache
        const persistedData = localStorage.getItem(ApiCache.API_CACHE_KEY);

        const currentCache: CacheDataInterface[] = persistedData ? JSON.parse(persistedData) : [];

        if (currentCache) {

            // filter OUT the item with the navigation data
            const filteredCurrentCache = currentCache.filter(cache => !cache.url.includes("/api/navigation-items"));

            // save updated cache to local storage
            localStorage.setItem(ApiCache.API_CACHE_KEY, JSON.stringify(filteredCurrentCache));

        }

    }

}